import { render, staticRenderFns } from "./science.vue?vue&type=template&id=34e2ad6d&"
import script from "./science.vue?vue&type=script&lang=js&"
export * from "./science.vue?vue&type=script&lang=js&"
import style0 from "./science.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports